import React from 'react';
import { Link } from 'react-router-dom';
import Programmesleft from './ProgrammesleftEle'
import { Container, Row, Col,Table } from 'react-bootstrap';



function MtechSelfSponsoredEle() {
  return (
    <section className="project-detail">
      <Container>
        <Row>
          <Col md={4} className='c-left custom-padding-color mb-4'>
            <Programmesleft activeIndex={6}/>
          </Col>

          <Col md={8} className='c-right'>
           
           
            <div className="c-heading">
              <h3>M.Tech. Self-Sponsored</h3>
              </div>
            <p>
              IIT Tirupati offers M.Tech. Self-Sponsored program(s) in the following Departments:
            </p>

            <ul className='myulcustarrow'>
            <li>
              	The Department of Chemical Engineering has started a self-sponsored post graduate program M.Tech. in Chemical Engineering from the Academic Year 2026-27.
              </li>
              <li>
                		The Department of Computer Science and Engineering offers a self-sponsored post graduate program M.Tech. in Data Science & Artificial Intelligence from the Academic Year 2025-26.
              </li>
              
              
            </ul>


            <Table bordered responsive className='mt-3'>
              <thead>
                <tr>
                  <th>Department</th>
                  <th>Intake</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Chemical Engineering</td>
                  <td>5</td>
                </tr>
                
                <tr>
                  <td>Computer Science and Engineering</td>
                  <td>10</td>
                </tr>
                
              </tbody>
            </Table>
     
    
              For more information{' '}
              <b>
              <Link to="/m-tech-self-sponsored-admission" target="_blank" rel="noopener noreferrer" className='c-link'>
                  click here
                </Link>
              </b>
          </Col>
        </Row>
      </Container>

    </section>
  );
}

export default MtechSelfSponsoredEle;
